module.exports = __webpack_public_path__ + "img/li.883b0b83.png";